import React, { useState, useRef } from "react";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";

const GameCardForMerchant = ({ item, handleSelect, isSelected, isDisabled, setSelectedGames }) => {
    const [show, setShow] = useState(false);
    const target = useRef(null);

    const isSelectedCard = (array, object) => array?.some((g) => g.gameId === object.gameId);
    const selected = isSelectedCard(isSelected, { gameId: item?.gameId });

    const selectedGame = isSelected.find((g) => g.gameId === item.gameId);
    const isEdit = selectedGame?.isEdit ?? false;

    const handleEditClick = (e) => {
        e.stopPropagation();
        setSelectedGames((prev) =>
            prev.map((g) =>
                g.gameId === item.gameId ? { ...g, isEdit: !g.isEdit } : g
            )
        );
    };
    return (
        <div
            ref={target}
            onMouseEnter={() => isDisabled && setShow(true)}
            onMouseLeave={() => setShow(false)}
            className="gamecard_wrapper"
        >
            <div
                className={`giftcard_voucher_box ${selected ? "selected_voucher" : ""} ${isDisabled ? "disabled_game" : ""
                    }`}
            >
                {selected && (
                    <span className="giftcard_selected_check">
                        <i className="fa-solid fa-check fa-xl"></i>
                    </span>
                )}

                <div
                    className="game_imagebox"
                    onClick={(e) => {
                        if (isDisabled) return;
                        e.preventDefault();
                        handleSelect(item.gameId, selected ? "Unselect" : "Select", item);
                    }}
                >
                    <img src={item?.imageUrl} alt={item?.gameName || "Game"} />
                    <div className={"gc_overlay"}>
                        <div className={"gc_overlay_box"}>
                            <span className={"hover_text"}>
                                {selected ? "Click to Unselect" : "Click to Select"}
                                {selected && (
                                    <span
                                        className="edit_icon"
                                        onClick={handleEditClick}
                                        style={{
                                            marginLeft: "10px",
                                            cursor: "pointer",
                                            color: "#fff",
                                        }}
                                    >
                                        <i className="fa-solid fa-pen-to-square"></i>
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row giftcard_voucher_details">
                    <div className="giftcard_voucher_title">
                        <h5>{item?.gameName}</h5>
                    </div>
                    {selected && (
                        <div className="giftcard_voucher_points">
                            <span>Points</span>

                            {isEdit ? (
                                item?.gameId === "spin55254" ? (
                                    <div
                                        className="spin-points-grid"
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, 1fr)",
                                            gap: "8px",
                                            marginTop: "8px",
                                        }}
                                    >
                                        {[0, 1, 2, 3, 4, 5].map((index) => {
                                            const selectedGame = isSelected.find((g) => g.gameId === item.gameId);
                                            const pointsArray = Array.isArray(selectedGame?.points)
                                                ? selectedGame.points
                                                : ["", "", "", "", "", ""];
                                            return (
                                                <input
                                                    key={index}
                                                    name={`spinPoint${index}`}
                                                    type="text"
                                                    maxLength={4}
                                                    value={pointsArray[index] || ""}
                                                    onChange={(e) => {
                                                        const onlyNums = e.target.value.replace(/\D/g, "");
                                                        setSelectedGames((prev) =>
                                                            prev.map((g) =>
                                                                g.gameId === item.gameId
                                                                    ? {
                                                                        ...g,
                                                                        points: (() => {
                                                                            const updated = [...pointsArray];
                                                                            updated[index] = onlyNums;
                                                                            return updated;
                                                                        })(),
                                                                    }
                                                                    : g
                                                            )
                                                        );
                                                    }}
                                                    className="spin-point-input"
                                                    style={{
                                                        width: "34px",
                                                        textAlign: "center",
                                                        padding: "4px",
                                                        borderRadius: "6px",
                                                    }}
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <>
                                        <input
                                            name="points"
                                            type="text"
                                            maxLength={4}
                                            value={
                                                isSelected.find((g) => g.gameId === item.gameId)?.points || ""
                                            }
                                            onChange={(e) => {
                                                const onlyNums = e.target.value.replace(/\D/g, "");
                                                const numValue = onlyNums === "" ? "" : Number(onlyNums);
                                                setSelectedGames((prev) =>
                                                    prev.map((g) =>
                                                        g.gameId === item.gameId ? { ...g, points: [numValue] } : g
                                                    )
                                                );
                                            }}
                                            className="points-input"
                                            style={{
                                                marginTop: "8px",
                                                width: "80px",
                                                textAlign: "center",
                                                padding: "4px",
                                                borderRadius: "6px",
                                            }}
                                        />
                                    </>
                                )
                            ) : item?.gameId === "spin55254" ? (
                                <div style={{ color: "white" }}>
                                    {(() => {
                                        const selected = isSelected.find((g) => g.gameId === item.gameId);
                                        const pointsArray = Array.isArray(selected?.points) ? selected.points : [];

                                        const nonEmpty = pointsArray?.filter(
                                            (p) => p !== null && p !== undefined && String(p).trim() !== ""
                                        );

                                        return nonEmpty.length > 0 ? nonEmpty.join(" | ") : "0";
                                    })()}
                                </div>
                            ) : (
                                <span style={{ display: "block" }}>
                                    {(() => {
                                        const pointsValue =
                                            isSelected.find((g) => g.gameId === item.gameId)?.points;
                                        return pointsValue && pointsValue !== "" ? pointsValue : "0";
                                    })()}
                                </span>
                            )}
                        </div>
                    )}

                </div>
            </div>

            {isDisabled && (
                <Overlay target={target.current} show={show} placement="auto">
                    {(props) => (
                        <Tooltip id={`tooltip-${item?.gameId}`} {...props}>
                            Access to this game is disabled for your account.
                            <br />
                            Kindly reach out to your account manager for assistance.
                        </Tooltip>
                    )}
                </Overlay>
            )}
        </div>
    );
};

export default GameCardForMerchant;
